type CouponWithPercentLabel = {
  type: string;
  formattedDiscount?: string | null;
};

export const getCouponPercentLabel = (
  coupon: CouponWithPercentLabel | null | undefined,
  percentageType: string,
): string | undefined => {
  if (!coupon || coupon.type !== percentageType) {
    return undefined;
  }

  return coupon.formattedDiscount ? `(-${coupon.formattedDiscount})` : undefined;
};
